module.exports = __webpack_public_path__ + "static/plus-user-avatar-icon-5e17094112ee9f0d527e0e6cd20e9a99.svg";